import { lazy } from 'react'

export const GuestMetricsLazy = lazy(() => import('./GuestMetrics'))
